import { render } from "./apremioList.vue?vue&type=template&id=775ca378"
import script from "./apremioList.vue?vue&type=script&lang=js"
export * from "./apremioList.vue?vue&type=script&lang=js"

import "./apremioList.vue?vue&type=style&index=0&id=775ca378&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__